import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LayoutContextType {
  title: string;
  icon: string;
  headerContent?: ReactNode;
  footerContent?: ReactNode;
  setTitle: (title: string) => void;
  setIcon: (icon: string) => void;
  setHeaderContent: (content: ReactNode) => void;
  setFooterContent: (content: ReactNode) => void;
  clearOnUnmount: () => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

export const LayoutProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState<string>(''); // use this to rename header on container
  const [icon, setIcon] = useState<string>('/svgs/icon-container.svg');
  const [headerContent, setHeaderContent] = useState<ReactNode>();
  const [footerContent, setFooterContent] = useState<ReactNode>();

  // restore to default
  const clearOnUnmount = () => {
    setTitle('Video Screener');
    setIcon('/svgs/icon-container.svg');
  }

  const value = {
    title,
    icon,
    headerContent,
    footerContent,
    setTitle,
    setIcon,
    setHeaderContent,
    setFooterContent,
    clearOnUnmount
  };

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};